<template>
  <div class="card" style="margin: 3rem">
    <header class="card-header">
      <p class="card-header-title">#{{ client.id }} - {{ client.name }}</p>
    </header>
    <div class="card-content">
      <div
        v-for="point in points"
        :key="point.id"
        class="content"
      >#{{ point.id }}({{ formatStatus(point.status) }}) - {{ point.plan.name }}</div>
    </div>
    <footer class="card-footer">
      <a
        class="card-footer-item disabled"
        disabled
        :class="{ active: selected === true }"
        @click="canContinue(true)"
      >Ponto novo</a>
      <a
        class="card-footer-item"
        :class="{ active: selected === false }"
        @click="canContinue(false)"
      >Ponto existente</a>
    </footer>
    <br>
    <div class="row">
          <div class="col-md-12">
            <div>
              <input style="margin-left: 5px"
                type="checkbox"
                id="fidelidade"
                name="fidelidade"
                v-on:change="changeLoyalty"
              />
              <label style="margin-left: 5px" for="fidelidade">
                <span class="p_fidelidade">Ponto possui fidelidade ?</span>
              </label>
            </div>
          </div>
        </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  props: ["currentStep"],
  computed: {
    client() {
      return this.$store.getters.client;
    },
    points() {
      return this.$store.getters.points;
    }
  },
  data() {
    return {
      selected: null,
    };
  },
  methods: {
    ...mapActions(["setNewClient","setLoyalty"]),
    changeLoyalty(e) {
      this.setLoyalty(e.target.checked);
    },
    canContinue(selected) {
      this.selected = selected;
      this.setNewClient(selected);
      this.$emit("can-continue", { value: true });
    },
    formatStatus(value) {
      const map = new Map([
        [19, "Aguardando 1. Conexão"],
        [27, "ATIVO"],
        [58, "AVISO"],
        [43, "BLOQUEADO"],
        [26, "NÃO INSTALADO"],
        [35, "CONGELADO"],
        [51, "CANCELADO"],
        [52, "CANCELADO INADIMPL."],
        [96, "ISENTO"],
        [105, "AGUARDANDO ACEITE"]
      ]);
      return map.get(value);
    }
  },
  mounted() {
    //            this.$emit('can-continue', {value: true})
  }
};
</script>

<style scoped>
.p_fidelidade {
  font-weight: bold;
  color: #000;
  font-size: 18px;
}
.active {
  background-color: #3383c8;
  color: #fff;
}

.content {
  text-align: center;
  padding: 20px;
}
.card {
  box-shadow: 0 0px 4px rgb(0 0 0 / 59%);
}
.card-footer-item {
  cursor: pointer;
  padding: 10px;
  border-radius: 3px;
}
.disabled {
  display: none;
}
.card-header-title {
  font-weight: bold;
}
.card-footer {
  display: flex;
  justify-content: space-around;
}
</style>